module.exports = __webpack_public_path__ + "media/performance/person-star-0df73c54.svg";